var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6012 13.2235V18.1412C11.6012 20.5712 13.5712 22.5412 16.0012 22.5412C18.4313 22.5412 20.4012 20.5712 20.4012 18.1412V11.9294C20.4012 10.6429 19.3583 9.60001 18.0718 9.60001C16.7853 9.60001 15.7424 10.6429 15.7424 11.9294V17.8824M8.79991 3.20001H23.2002C24.9675 3.20001 26.4002 4.63273 26.4002 6.40007L26.3998 25.6001C26.3998 27.3674 24.9671 28.8 23.1998 28.8L8.79978 28.7999C7.03246 28.7999 5.59978 27.3672 5.59979 25.5999L5.59991 6.39999C5.59993 4.63269 7.03261 3.20001 8.79991 3.20001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach-file.16b24d24ce3ede6d1ca8231adbf7e861.svg";
export { ForwardRef as ReactComponent };